import axios from "axios";

// Each tab keeps its session in sessionStorage; "keep me signed in" lives only in an HttpOnly cookie set by the server.
const TAB = "dp_tab_session";
const COMPANY = "dp_company";
const LAST_EMAIL = "dp_last_email";
const ENV_OF = { admin: "interno", backoffice: "interno", empresa: "empresa", funcionario: "funcionario" };
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const read = (store, k) => { try { return JSON.parse(store.getItem(k)); } catch { return null; } };
const write = (store, k, v) => store.setItem(k, JSON.stringify(v));

["dp_access", "dp_refresh", "dp_company", "dp_remember_interno", "dp_remember_empresa", "dp_remember_funcionario"].forEach((k) => localStorage.removeItem(k));

export const envGroup = (u) => ENV_OF[u?.env];

export const pathEnv = () => {
  const p = window.location.pathname;
  if (p.startsWith("/admin") || p.startsWith("/backoffice")) return ["interno"];
  if (p.startsWith("/empresa")) return ["empresa"];
  if (p.startsWith("/funcionario")) return ["funcionario"];
  if (p.startsWith("/admissao") || p === "/") return [];
  return ["interno", "empresa", "funcionario"];
};

export const session = () => read(sessionStorage, TAB);
export const accessToken = () => session()?.access || null;
export const refreshToken = () => session()?.refresh || null;

export async function resumeSession(envs = pathEnv()) {
  if (!envs.length) return null;
  try {
    const { data } = await axios.post(`${API}/auth/resume`, { envs });
    write(sessionStorage, TAB, { access: data.access_token, refresh: null, user_id: data.user.id, env: data.env, remember: true });
    return data.access_token;
  } catch { return null; }
}

export function saveSession({ access, refresh, user, remember }) {
  write(sessionStorage, TAB, { access, refresh, user_id: user.id, env: envGroup(user), remember });
  sessionStorage.removeItem(COMPANY);
}

export function updateAccess(access) {
  const s = session();
  if (s) write(sessionStorage, TAB, { ...s, access });
}

export function clearSession() {
  sessionStorage.removeItem(TAB);
  sessionStorage.removeItem(COMPANY);
}

export const getStoredCompany = () => read(sessionStorage, COMPANY);
export const storeCompany = (c) => write(sessionStorage, COMPANY, c);
export const lastEmail = () => localStorage.getItem(LAST_EMAIL) || "";
export const rememberEmail = (email) => (email ? localStorage.setItem(LAST_EMAIL, email) : localStorage.removeItem(LAST_EMAIL));
